<div [ngClass]="{active: !isClosed}">
  <button (click)="handleButtonClick();">{{title}}</button>
  <ng-content *ngIf="!isClosed"></ng-content>
</div>